var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
import { backendUrl } from '@common/contracts';
/** The catalog of playable agents (from the seeded Vision Makers set). */
export function getAgents() {
    return __awaiter(this, void 0, void 0, function* () {
        const list = yield client.get('/agents');
        // Portraits localized into our GridFS come back as relative `/uploads/<id>` paths;
        // prefix the backend origin. Any remaining absolute CDN url is left as-is.
        return list.map((a) => (Object.assign(Object.assign({}, a), { imageUrl: a.imageUrl && !a.imageUrl.startsWith('http') ? `${backendUrl}${a.imageUrl}` : a.imageUrl })));
    });
}
